<template>
  <div class="report-fee-summary-container animated fadeInRight">
    <el-row class="flex justify-start" :gutter="20">
      <el-col :span="3" class="padding-r-0">
        <select-community-floor ref="selectCommunityFloor" />
      </el-col>
      <el-col :span="21">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{ $t('reportFeeSummary.queryCondition') }}</span>
          </div>
          <div class="text item">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-date-picker v-model="reportFeeSummaryInfo.conditions.startDate" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('reportFeeSummary.selectStartDate')" style="width: 100%"
                  @change="handleDateChange" />
              </el-col>
              <el-col :span="4">
                <el-date-picker v-model="reportFeeSummaryInfo.conditions.endDate" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('reportFeeSummary.selectEndDate')" style="width: 100%" @change="handleDateChange" />
              </el-col>
              <!-- 房屋维度下，业主名称和手机号仅作展示，不参与筛选 -->
              <el-col :span="12">
                <el-input v-model.trim="reportFeeSummaryInfo.conditions.objName"
                  :placeholder="$t('reportFeeSummary.inputRoomNumber')" clearable />
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="_queryMethod">
                  <i class="el-icon-search"></i>
                  {{ $t('common.search') }}
                </el-button>
                <el-button @click="_resetMethod">
                  <i class="el-icon-refresh"></i>
                  {{ $t('common.reset') }}
                </el-button>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="margin-top">
              <el-col :span="4">
                <el-select v-model="reportFeeSummaryInfo.conditions.feeTypeCd"
                  :placeholder="$t('reportFeeSummary.selectFeeType')" style="width: 100%" clearable>
                  <el-option v-for="(item, index) in reportFeeSummaryInfo.feeTypeCds" :key="index" :label="item.name"
                    :value="item.statusCd" />
                </el-select>
              </el-col>
              <el-col v-if="reportFeeSummaryInfo.communitys.length > 1" :span="4">
                <el-select v-model="reportFeeSummaryInfo.conditions.communityId"
                  :placeholder="$t('reportFeeSummary.selectCommunity')" style="width: 100%" @change="_changCommunity">
                  <el-option v-for="(item, index) in reportFeeSummaryInfo.communitys" :key="index" :label="item.name"
                    :value="item.communityId" />
                </el-select>
              </el-col>
            </el-row>

            <el-row v-show="reportFeeSummaryInfo.moreCondition" class="margin-top">
              <el-col :span="24">
                <el-checkbox-group v-model="reportFeeSummaryInfo.configIds">
                  <el-checkbox v-for="(item, index) in reportFeeSummaryInfo.feeConfigs" :key="index"
                    :label="item.configId">
                    {{ item.feeName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card margin-top">
          <div slot="header" class="flex justify-between">
            <div>
              <span>{{ $t('reportFeeSummary.feeSummaryTable') }}</span>
              <span class="el-icon-info popover-show" style="cursor: pointer;"></span>
              <span>({{ $t('reportFeeSummary.updateDaily') }})</span>
            </div>
            <div style="float: right;">
              <el-popover placement="bottom" width="220" trigger="click">
                <div class="column-selector">
                  <el-checkbox-group v-model="visibleCols">
                    <el-checkbox v-for="item in columnOptions" :key="item.key" :label="item.key" class="column-option">
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <el-button slot="reference" size="small" style="margin-right: 10px;">
                  <i class="el-icon-s-operation"></i>
                  列显隐
                </el-button>
              </el-popover>
              <el-button type="primary" size="small" @click="_exportExcel">
                <i class="el-icon-download"></i>
                {{ $t('common.export') }}
              </el-button>
              <el-button type="warning" size="small" @click="_exportOweRoomDetail">
                <i class="el-icon-download"></i>
                导出欠费户明细
              </el-button>
            </div>
          </div>
          <div class="text item">
            <el-table :data="reportFeeSummaryInfo.fees" border style="width: 100%">
              <el-table-column v-if="visibleCols.includes('roomCount')" prop="roomCount" :label="$t('reportFeeSummary.totalRooms')" :render-header="renderHeader" align="center" />
              <el-table-column v-if="visibleCols.includes('configRoomCount')" prop="configRoomCount" :label="$t('reportFeeSummary.configRooms')" :render-header="renderHeader" align="center" />
              <el-table-column v-if="visibleCols.includes('feeRoomCount')" prop="feeRoomCount" :label="$t('reportFeeSummary.receivableRooms')" :render-header="renderHeader" align="center" />
              <el-table-column v-if="visibleCols.includes('oweRoomCount')" prop="oweRoomCount" :label="$t('reportFeeSummary.arrearsRooms')" :render-header="renderHeader" align="center" />
              <el-table-column v-if="visibleCols.includes('paidRoomCount')" prop="paidRoomCount" :label="$t('reportFeeSummary.paidRooms')" :render-header="renderHeader" align="center" />
              <el-table-column v-if="visibleCols.includes('curPaidRoomCount')" prop="curPaidRoomCount" :label="$t('reportFeeSummary.curPaidRooms')" :render-header="renderHeader" align="center" />
              <el-table-column align="center" colspan="3">
                <template slot="header">
                  {{ $t('reportFeeSummary.arrearsFormula') }}
                  <el-tooltip content="历史欠费 + 当期欠费 = 总欠费" placement="top">
                    <i class="el-icon-warning-outline header-tip-icon" />
                  </el-tooltip>
                </template>
                <el-table-column v-if="visibleCols.includes('hisOweFee')" prop="hisOweFee" :label="$t('reportFeeSummary.historyArrears')" :render-header="renderHeader" align="center" />
                <el-table-column v-if="visibleCols.includes('curOweFee')" prop="curOweFee" :label="$t('reportFeeSummary.currentArrears')" :render-header="renderHeader" align="center" />
                <el-table-column v-if="visibleCols.includes('totalArrears')" align="center">
                  <template slot="header">
                    {{ $t('reportFeeSummary.totalArrears') }}
                    <el-tooltip content="历史欠费 + 当期欠费" placement="top">
                      <i class="el-icon-warning-outline header-tip-icon" />
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    {{ (scope.row.curOweFee + scope.row.hisOweFee).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column align="center" colspan="6">
                <template slot="header">
                  {{ $t('reportFeeSummary.actualPaymentFormula') }}
                  <el-tooltip content="欠费追回 + 当期部分 + 预交 + 应缴总额 + 实缴总额 + 优惠金额 = 费用金额" placement="top">
                    <i class="el-icon-warning-outline header-tip-icon" />
                  </el-tooltip>
                </template>
                <el-table-column v-if="visibleCols.includes('hisReceivedFee')" prop="hisReceivedFee" :label="$t('reportFeeSummary.arrearsRecovery')" :render-header="renderHeader" align="center" />
                <el-table-column v-if="visibleCols.includes('currentPartial')" align="center">
                  <template slot="header">
                    {{ $t('reportFeeSummary.currentPartial') }}
                    <el-tooltip content="实缴总额 - 欠费追回 - 预交（小于0时取0）" placement="top">
                      <i class="el-icon-warning-outline header-tip-icon" />
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    {{ Math.max(0, scope.row.receivedFee - scope.row.hisReceivedFee - scope.row.preReceivedFee).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column v-if="visibleCols.includes('preReceivedFee')" prop="preReceivedFee" :label="$t('reportFeeSummary.advancePayment')" :render-header="renderHeader" align="center" />
                <el-table-column v-if="visibleCols.includes('receivableFee')" prop="receivableFee" :label="$t('reportFeeSummary.receivableTotal')" :render-header="renderHeader" align="center" />
                <el-table-column v-if="visibleCols.includes('receivedFee')" prop="receivedFee" :label="$t('reportFeeSummary.actualPayment')" :render-header="renderHeader" align="center" />
                <el-table-column v-if="visibleCols.includes('discountFee')" align="center">
                  <template slot="header">
                    {{ $t('reportFeeSummary.discountFee') }}
                    <el-tooltip content="应缴总额 - 实缴总额（小于0时取0）" placement="top">
                      <i class="el-icon-warning-outline header-tip-icon" />
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    {{ Math.max(0, scope.row.receivableFee - scope.row.receivedFee).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column v-if="visibleCols.includes('curReceivableFee')" prop="curReceivableFee" :label="$t('reportFeeSummary.currentReceivable')" :render-header="renderHeader" align="center" />
              <el-table-column v-if="visibleCols.includes('curActualReceivedFee')" align="center">
                <template slot="header">
                  {{ $t('reportFeeSummary.currentActual') }}
                  <el-tooltip content="查询时间范围内费用所属月份的实际到账金额合计" placement="top">
                    <i class="el-icon-warning-outline header-tip-icon" />
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.curActualReceivedFee ? scope.row.curActualReceivedFee.toFixed(2) : '0.00' }}
                </template>
              </el-table-column>
              <el-table-column v-if="visibleCols.includes('roomChargeRate')" align="center">
                <template slot="header">
                  {{ $t('reportFeeSummary.roomChargeRate') }}
                  <el-tooltip content="（应收户数 - 欠费户）/ 应收户数" placement="top">
                    <i class="el-icon-warning-outline header-tip-icon" />
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.feeRoomCount > 0 ? (((scope.row.feeRoomCount - scope.row.oweRoomCount) /
                    scope.row.feeRoomCount * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
              <el-table-column v-if="visibleCols.includes('chargeRate')" align="center">
                <template slot="header">
                  {{ $t('reportFeeSummary.chargeRate') }}
                  <el-tooltip content="当期实收 / 当期应收" placement="top">
                    <i class="el-icon-warning-outline header-tip-icon" />
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ scope.row.curReceivableFee > 0 ? ((scope.row.curActualReceivedFee /
                    scope.row.curReceivableFee * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
              <el-table-column v-if="visibleCols.includes('clearanceRate')" align="center">
                <template slot="header">
                  {{ $t('reportFeeSummary.clearanceRate') }}
                  <el-tooltip content="欠费追回 / （欠费追回 + 历史欠费）" placement="top">
                    <i class="el-icon-warning-outline header-tip-icon" />
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  {{ (scope.row.hisReceivedFee + scope.row.hisOweFee) > 0 ? ((scope.row.hisReceivedFee /
                    (scope.row.hisReceivedFee + scope.row.hisOweFee) * 100).toFixed(2) + '%') : '0%' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>

        <div class="margin-top">
          <floor-fee-summary ref="floorFeeSummary" />
        </div>
        <div class="margin-top">
          <config-fee-summary ref="configFeeSummary" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDict, getCommunityId } from '@/api/community/communityApi'
import { queryReportFeeSummary, exportData, queryCommunitys, queryFeeConfigs } from '@/api/report/reportFeeSummaryApi'
import { dateFormat } from '@/utils/dateUtil'
import SelectCommunityFloor from '@/components/report/selectCommunityFloor'
import FloorFeeSummary from '@/components/report/floorFeeSummary'
import ConfigFeeSummary from '@/components/report/configFeeSummary'

export default {
  name: 'ReportFeeSummaryList',
  components: {
    SelectCommunityFloor,
    FloorFeeSummary,
    ConfigFeeSummary
  },
  data() {
    return {
      fieldDescMap: {
        roomCount: '查询范围内小区/楼栋的房屋总数',
        configRoomCount: '配置了查询费用类型的房屋总数，不受查询时间范围影响',
        feeRoomCount: '查询时间范围内存在应收账单（应收金额大于0）的房屋数（按月动态）',
        oweRoomCount: '查询时间范围内有应收账单但未缴清的房屋数',
        paidRoomCount: '查询时间范围内当期有应收账单且已缴清的房屋数（应收户数 - 欠费户数）',
        curPaidRoomCount: '查询时间范围内有实际缴费记录（按支付时间）的房屋数；只看实际支付时间是否落在查询区间内，不区分缴纳的是哪个月份的账单(包含:预交预存费用)',
        hisOweFee: '历史欠费 = 查询开始日期之前的欠费：查询开始日期之前累计未缴的净欠费金额（应收 - 实收 - 优惠）',
        curOweFee: '查询时间范围内当期应缴账单扣除所有已缴金额后的净欠费（已扣减查询时间范围外补缴/预缴的当期账单；应收 - 全时段实收 - 优惠）',
        curReceivableFee: '查询时间范围内所有计费记录的应收金额合计（含当期账单、补缴、预交记录）',
        curActualReceivedFee: '查询时间范围内费用所属月份且实际支付时间也在查询范围内的到账金额合计（仅支付记录，不含优惠）',
        hisReceivedFee: '查询时间范围内补缴的历史欠费金额',
        preReceivedFee: '查询时间范围内缴纳的预付款金额',
        receivedFee: '查询时间范围内实际到账金额（净到账，已扣除退费），即实缴总额',
        receivableFee: '查询时间范围内与实缴同口径的应缴金额合计（优惠前金额），即应缴总额',
        discountFee: '应缴总额 - 实缴总额（小于0时取0），即优惠金额'
      },
      columnOptions: [
        { key: 'roomCount', label: '总户数' },
        { key: 'configRoomCount', label: '费用配置户数' },
        { key: 'feeRoomCount', label: '应收户数' },
        { key: 'oweRoomCount', label: '欠费户' },
        { key: 'paidRoomCount', label: '已缴户数' },
        { key: 'curPaidRoomCount', label: '本期缴费户数' },
        { key: 'hisOweFee', label: '历史欠费' },
        { key: 'curOweFee', label: '当期欠费' },
        { key: 'totalArrears', label: '总欠费' },
        { key: 'hisReceivedFee', label: '欠费追回' },
        { key: 'currentPartial', label: '当期部分' },
        { key: 'preReceivedFee', label: '预交' },
        { key: 'receivableFee', label: '应缴总额' },
        { key: 'receivedFee', label: '实缴总额' },
        { key: 'discountFee', label: '优惠金额' },
        { key: 'curReceivableFee', label: '当期应收' },
        { key: 'curActualReceivedFee', label: '当期实收' },
        { key: 'roomChargeRate', label: '户收费率' },
        { key: 'chargeRate', label: '收费率' },
        { key: 'clearanceRate', label: '清缴率' }
      ],
      visibleCols: [
        'configRoomCount',
        'feeRoomCount',
        'oweRoomCount',
        'paidRoomCount',
        'curPaidRoomCount',
        'totalArrears',
        'receivableFee',
        'receivedFee',
        'discountFee',
        'curReceivableFee',
        'curActualReceivedFee',
        'roomChargeRate',
        'chargeRate',
        'clearanceRate'
      ],
      reportFeeSummaryInfo: {
        fees: [],
        feeConfigs: [],
        floors: [],
        configIds: [],
        feeTypeCds: [],
        communitys: [],
        moreCondition: false,
        conditions: {
          floorId: '',
          objName: '',
          startDate: '',
          endDate: '',
          configId: '',
          feeTypeCd: '888800010001',
          ownerName: '',
          link: '',
          communityId: ''
        }
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    renderHeader(h, { column }) {
      const desc = this.fieldDescMap[column.property]
      if (!desc) {
        return h('span', column.label)
      }
      return h('span', [
        column.label,
        h('el-tooltip', {
          attrs: {
            content: desc,
            placement: 'top'
          }
        }, [
          h('i', {
            class: 'el-icon-warning-outline header-tip-icon'
          })
        ])
      ])
    },
    async initData() {
      this.reportFeeSummaryInfo.conditions.communityId = await getCommunityId()
      this._initDate()
      this._loadStaffCommunitys()
      this._listFeeConfigs()
      this.getFeeTypeDict()
      this.$refs.selectCommunityFloor.open({
        callBack: (floor) => {
          this.reportFeeSummaryInfo.conditions.floorId = floor.floorId
          this._listFees()
        }
      })
      this._listFees()
    },
    _initDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth() + 1
      const lastDay = new Date(year, month, 0).getDate()
      const m = month.toString().padStart(2, '0')

      this.reportFeeSummaryInfo.conditions.startDate = `${year}-${m}-01 00:00:00`
      this.reportFeeSummaryInfo.conditions.endDate = `${year}-${m}-${lastDay} 23:59:59`
    },
    handleDateChange() {
      if (this.reportFeeSummaryInfo.conditions.startDate && this.reportFeeSummaryInfo.conditions.endDate) {
        const start = new Date(this.reportFeeSummaryInfo.conditions.startDate)
        const end = new Date(this.reportFeeSummaryInfo.conditions.endDate)

        if (start > end) {
          this.$message.error(this.$t('reportFeeSummary.dateError'))
          this.reportFeeSummaryInfo.conditions.endDate = ''
        }
      }
    },
    async getFeeTypeDict() {
      try {
        this.reportFeeSummaryInfo.feeTypeCds = await getDict('pay_fee_config', 'fee_type_cd')
      } catch (error) {
        console.error('Failed to get fee type dict:', error)
      }
    },
    async _listFees() {
      try {
        const params = {
          page: 1,
          row: 100,
          ...this.reportFeeSummaryInfo.conditions,
        }

        // value-format 已保证为 yyyy-MM-dd HH:mm:ss 字符串，直接透传即可；
        // 仅对 Date 对象做兜底格式化，避免外部组件传入 Date 时 axios 序列化异常。
        if (params.startDate instanceof Date) {
          params.startDate = dateFormat(params.startDate) + ' 00:00:00'
        }
        if (params.endDate instanceof Date) {
          params.endDate = dateFormat(params.endDate) + ' 23:59:59'
        }

        if (this.reportFeeSummaryInfo.configIds.length > 0) {
          params.configIds = this.reportFeeSummaryInfo.configIds.join(',');
        }

        // 定义需要查询的字段类型
        const queryTypes = [
          'roomCount',
          'configRoomCount',
          'feeRoomCount',
          'oweRoomCount',
          'paidRoomCount',
          'curPaidRoomCount',
          'hisOweFee',
          'curOweFee',
          'curReceivableFee',
          'curActualReceivedFee',
          'hisReceivedFee',
          'preReceivedFee',
          'receivedFee',
          'receivableFee'
        ]

        // 合并结果的对象
        const mergedResult = {}

        // 串行查询每个字段
        for (const queryType of queryTypes) {
          try {
            const queryParams = { ...params, queryType }
            const { data } = await queryReportFeeSummary(queryParams)
            if (data && data.length > 0 && data[0]) {
              // 将返回的数据合并到结果对象中
              Object.assign(mergedResult, data[0])
            }
          } catch (error) {
            console.error(`Failed to query ${queryType}:`, error)
            // 如果某个字段查询失败，设置为默认值
            const fieldName = queryType === 'roomCount' || queryType === 'feeRoomCount' || queryType === 'oweRoomCount' ? queryType : queryType
            mergedResult[fieldName] = queryType.includes('Count') ? 0 : 0.00
          }
        }

        // 将合并后的结果放入数组中（因为表格期望数组格式）
        this.reportFeeSummaryInfo.fees = [mergedResult]

        // 通知子组件查询（子组件内部自己查询）
        if (this.$refs.floorFeeSummary) {
          this.$refs.floorFeeSummary.notify(params)
        }
        if (this.$refs.configFeeSummary) {
          this.$refs.configFeeSummary.notify(params)
        }
      } catch (error) {
        console.error('Failed to query fee summary:', error)
        this.$message.error(this.$t('reportFeeSummary.queryFailed') || '查询失败，请稍后重试')
      }
    },
    async _loadStaffCommunitys() {
      try {
        const data = await queryCommunitys()
        this.reportFeeSummaryInfo.communitys = data.communitys
      } catch (error) {
        console.error('Failed to load communities:', error)
      }
    },
    async _listFeeConfigs() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.reportFeeSummaryInfo.conditions.communityId,
          isDefault: 'F'
        }

        const data = await queryFeeConfigs(params)
        this.reportFeeSummaryInfo.feeConfigs = data.feeConfigs
      } catch (error) {
        console.error('Failed to list fee configs:', error)
      }
    },
    _queryMethod() {
      this._listFees()
    },
    _resetMethod() {
      this.reportFeeSummaryInfo.conditions = {
        ...this.reportFeeSummaryInfo.conditions,
        objName: '',
        feeTypeCd: '888800010001',
        floorName: '',
        floorId: '',
        unitId: '',
        configId: ''
      }
      this.reportFeeSummaryInfo.configIds = []
      this._listFees()
    },
    async _exportExcel() {
      try {
        const params = {
          ...this.reportFeeSummaryInfo.conditions,
          pagePath: 'reportFeeSummary'
        }

        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('Failed to export:', error)
        this.$message.error(this.$t('reportFeeSummary.exportFailed'))
      }
    },
    // 导出物业费欠费户明细：与"欠费户数/当期欠费"同口径，
    // 同一户查询区间内多月欠费汇总为一条，导出条数=欠费户数
    async _exportOweRoomDetail() {
      try {
        const params = {
          ...this.reportFeeSummaryInfo.conditions,
          pagePath: 'reportOweRoomDetail'
        }

        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('Failed to export owe room detail:', error)
        this.$message.error(this.$t('reportFeeSummary.exportFailed'))
      }
    },
    _changCommunity() {
      this._listFeeConfigs()
      this._listFees()
    }
  }
}
</script>

<style lang="scss" scoped>
.report-fee-summary-container {
  padding: 20px;

  .margin-top {
    margin-top: 20px;
  }

  .padding-r-0 {
    padding-right: 0;
  }

  .popover-show {
    margin-left: 10px;
    color: #409EFF;
  }

  .el-checkbox {
    margin-right: 15px;
  }

  .header-tip-icon {
    margin-left: 4px;
    color: #909399;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      color: #409EFF;
    }
  }

  .column-selector {
    max-height: 320px;
    overflow-y: auto;

    .column-option {
      display: block;
      margin-left: 0;
      margin-bottom: 8px;
    }
  }
}
</style>
